import { Experiences } from '@/models/Profile';

interface BuildExperiencesSavePayloadInput {
  documentRemoved: boolean;
  text: string;
  title: string;
  fileName: string;
  fileContents: string;
  existingDocument?: string | null;
  existingDocumentLabel?: string | null;
}

const buildExperiencesSavePayload = ({
  documentRemoved,
  text,
  title,
  fileName,
  fileContents,
  existingDocument,
  existingDocumentLabel,
}: BuildExperiencesSavePayloadInput): Experiences => {
  const currentDocument = documentRemoved
    ? null
    : (fileContents || existingDocument || null);
  const currentDocumentLabel = documentRemoved
    ? ''
    : (title || fileName || existingDocumentLabel || '');

  return {
    ...(currentDocument ? { experiencesDocument: currentDocument } : {}),
    experiencesText: text,
    experiencesDocumentLabel: currentDocumentLabel,
  };
};

export default buildExperiencesSavePayload;
